module.exports = __webpack_public_path__ + "static/media/Icon material-person.99978599.svg";